import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class PostsService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  /**
   * ყველა მენიუ
   */
  getMenus() {
    return this.http.get(`${environment.apiUrl}menus`);
  }

  /**
   * კონკრეტული მენიუ page-ის მიხედვით
   */
  getMenu(page: number) {
    return this.http.get(`${environment.apiUrl}menu/${page}`);
  }

  /**
   * ჩამოტანა ყველა list ტიპის გვერდის (listPages)
   */
  getListPages() {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}listPages?lang=${lang}`);
  }

  /**
   * ჩამოტანა კონკრეტული list-ის გვერდების/სიახლეების menu_page-ის მიხედვით
   */
  getPageByItems(params: any) {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/list`, {
      params: { ...params, lang }
    });
  }

  /**
   * პოსტის წაშლა (Admin)
   */
  delete(id: number = 0, source: string = ''){
    return this.http.post(`${environment.apiUrl}admin/delete/post`, { id, source });
  }

}